<template>
  <div>
    <b-row>
      <b-col xs="12">
        <h2 class="text-left mt-3 mb-5 font-weight-normal">Állandó szolgáltatások</h2>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col
        class="text-left mb-3"
        sm="12"
        md="12"
        lg="6"
        xl="4"
        v-for="(item, index) in services"
        :key="`service-${index}`"
      >
        <div
          :class="{ 'constant-services-holder-box': true, 'long-name': item.name.length >= 26 }"
          @click="navigateTo(item)"
        >
          {{ item.name }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { listServices } from '../api/service'
import openLinkNewTab from '../mixins/openLinkNewTab'
export default {
  mixins: [openLinkNewTab],
  name: 'ConstantServices',
  methods: {
    navigateTo: function(item) {
      if (item.openLinkInBlank) {
        this.openLinkNewTab(item.link)
      } else {
        window.location.href = item.link
      }
    }
  },
  created: async function() {
    const result = await listServices()
    this.services = result
  },
  data: function() {
    return {
      services: []
    }
  }
}
</script>

<style scoped>
.constant-services-holder-box {
  padding: 25px;
  border-top-right-radius: 0px;
  color: var(--color-green);
  position: relative;
  padding-left: 75px;
  font-size: 22px;
  border: 1px solid #dfe6e9;
  box-sizing: border-box;
  box-shadow: 0px 0px 8px rgba(45, 52, 54, 0.05);
  border-radius: 16px 0px 16px 16px;
}

.long-name {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
  font-size: 15px !important;
}

.constant-services-holder-box:hover {
  cursor: pointer;
}

.constant-services-holder-box:before {
  content: ' ';
  display: block;
  position: absolute;
  right: 0;
  top: 25%;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.7;
  background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 50px;
}
</style>
